/**
 * Burger menu (ouverture/fermeture) — voir header.php pour le markup
 * (bouton [data-js="menu-toggle"] + <nav id="c-menu">, alimenté par le
 * menu WordPress "Menu principal").
 */

export function render () {

  const burger = document.querySelector('[data-js="menu-toggle"]')
  const menu = document.querySelector('#c-menu')

  if (!burger || !menu) return

  const setOpen = (isOpen) => {
    document.body.classList.toggle('is-menu-open', isOpen)
    burger.setAttribute('aria-expanded', isOpen ? 'true' : 'false')
    burger.setAttribute('aria-label', isOpen ? 'Fermer le menu' : 'Ouvrir le menu')
    menu.setAttribute('aria-hidden', isOpen ? 'false' : 'true')
  }

  burger.addEventListener('click', () => {
    setOpen(!document.body.classList.contains('is-menu-open'))
  })

  // Ferme le menu quand on clique un lien (ou la touche Echap)
  menu.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', () => setOpen(false))
  })

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') setOpen(false)
  })

}
